import React from 'react';
import ReactDOM from 'react-dom';
import App from './routes/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./css/index.css";
import TagManager from 'react-gtm-module';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTMID
}
const msalInstance = new PublicClientApplication(msalConfig);

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);


